import { render, staticRenderFns } from "./AddModel.vue?vue&type=template&id=3a0ce1eb&"
import script from "./AddModel.vue?vue&type=script&lang=js&"
export * from "./AddModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports